import React from 'react';
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { getDecodedToken } from "../api/services/AuthService";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [initialized, setInitialized] = useState(false);
  const [decoded, setDecoded] = useState(null);

  const refreshAuth = () => {
    const token = getDecodedToken();
    setDecoded(token);
    setInitialized(true);
  };

  useEffect(() => {
    refreshAuth();
  }, []);

  const value = useMemo(() => {
    const isAuthenticated = !!decoded;
    const isAdmin = decoded?.admin === true;
    const isPasswordDefault = decoded?.reset === true;
    const roles = Array.isArray(decoded?.roles) ? decoded.roles : [];

    const canAccessView = ({ view, roles: requiredRoles = [] }) => {
      
      if (!isAuthenticated) return false;

      if (!isPasswordDefault) {
        return view === "resetSenha";
      }

      if (isAdmin) {
        return view !== "dashboard" && view !== "config";
      }

      if (!requiredRoles || requiredRoles.length === 0) return true;

      return requiredRoles.some((r) => roles.includes(r));
    };

    return {
      initialized,
      refreshAuth,
      decoded,
      isAuthenticated,
      isAdmin,
      isPasswordDefault,
      roles,
      canAccessView,
    };
  }, [initialized, decoded]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);